<template>
    <div class="faq">
        <h1>This is an FAQ page</h1>
    </div>
</template>

<script>
export default {
    components: {
        
    },
    data() {
        return {}
    },
    computed: {}
}
</script>